import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { options } from '../../../../utils/actions'
import { $post } from '../../../../utils/apis'
import { formatRequest, formatUrl } from '../../common/formatRequest'
import { statusResponse } from '../../common/json/staticData.json'

export const fieldSwitchSubAppAction = createAction('FIELD_SWITCH_SUBAPP')

export const postCalculation = createAsyncThunk(
  'request/calculation',
  async (input, { rejectWithValue, signal }) => {
    const source = axios.CancelToken.source()

    signal.addEventListener('abort', () => {
      source.cancel()
    })

    try {
      const inputErrors = Object.values(input.validation);
      if (inputErrors.length) {
        return rejectWithValue({
          msgLevel: 'error',
          msgHeader: 'Input Validation Error',
          msgBody: inputErrors.join('<br />'),
        })
      }
      const url = formatUrl(input)
      const body = formatRequest(input)
      const { data } = await $post(url, body, { ...options, cancelToken: source.token })

      if (data.statusCode !== 200) {
        return rejectWithValue({
          msgLevel: 'error',
          msgHeader: 'Calculation',
          msgBody: `${data.statusText}-${data.errors[0]}`,
        })
      }

      if (!data.summary?.length) {
        return rejectWithValue(statusResponse.NO_OUTPUT_RESULTS)
      }

      return data
    } catch (err) {
      return rejectWithValue(statusResponse.NETWORK_ERROR)
    }
  },
)
